<template>
    <div>
        <MainPage
            v-if="!isSettings"
            @open-settings="openSettings"
        />
        <SettingsPage
            v-else
            @accept-policies="acceptPolicies"
            @reject-policies="rejectPolicies"
            @save-custom-settings="saveSettings"
        />
    </div>
</template>

<script>
    import MainPage from '@/components/gdpr/pages/MainPage';
    import SettingsPage from '@/components/gdpr/pages/SettingsPage';

    export default {
        name: 'DisclaimerBody',
        props: {
            isSettings: {
                type: Boolean,
                required: true
            }
        },
        components: {
            MainPage,
            SettingsPage
        },
        methods: {
            acceptPolicies() {
                this.$emit('accept-policies');
            },
            openSettings() {
                this.$emit('open-settings');
            },
            rejectPolicies() {
                this.$emit('reject-policies');
            },
            saveSettings() {
                this.$emit('save-custom-settings');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/layout/DisclaimerBody.vue